import { axiosApiInstancePrivate } from '../index';
import axios, { AxiosError } from 'axios';

export interface BestIdResult {
  lead_id?: string;
  best_id: string;
  distance: number;
  consultant_name?: string;
}

const rethrowApiError = (err: unknown): never => {
  const error = err as Error | AxiosError;
  if (axios.isAxiosError(error)) {
    throw error?.response?.data;
  }
  throw err;
};

export const createCappelloParlanteApi = (basePath: string) => ({
  getCurrentVersion: async () => {
    try {
      const response = await axiosApiInstancePrivate.get(`${basePath}/ping`);
      return response?.data?.version || 'not available';
    } catch (err) {
      return rethrowApiError(err);
    }
  },

  getBestId: async (leadId: string, isStage = false): Promise<BestIdResult> => {
    try {
      const response = await axiosApiInstancePrivate.post(`${basePath}/get-best-id`, {
        lead_id: leadId,
        use_staging: isStage,
      });

      return response.data;
    } catch (err) {
      return rethrowApiError(err);
    }
  },

  retrainStage: async () => {
    try {
      const response = await axiosApiInstancePrivate.get(`${basePath}/start-staging-training`);
      return response;
    } catch (err) {
      return rethrowApiError(err);
    }
  },

  retrainProduction: async () => {
    try {
      const response = await axiosApiInstancePrivate.get(`${basePath}/start-production-training`);
      return response;
    } catch (err) {
      return rethrowApiError(err);
    }
  },

  isTrainingInProgress: async () => {
    try {
      const response = await axiosApiInstancePrivate.get(`${basePath}/is-training-in-progress`);
      return response?.data?.training_in_progress || false;
    } catch (err) {
      return rethrowApiError(err);
    }
  },
});

export type CappelloParlanteApi = ReturnType<typeof createCappelloParlanteApi>;

export const cappelloMutuiApi = createCappelloParlanteApi('/v1/cappello-parlante');
export const cappelloPrestitiApi = createCappelloParlanteApi('/v1/cappello-prestiti');
export const cappelloCessioniApi = createCappelloParlanteApi('/v1/cappello-cessioni');
